module.exports = __webpack_public_path__ + "static/media/logo-zurich-white.4e69f354.svg";